import { StringId } from '../localizer/stringId'

export const strings = {
  // TODO: change this to AVOD_DP_E_error_reload_text when it's been translated
  [StringId.AVOD_DP_E_error_text]: 'An unknown error has occured. Please try again later',
  [StringId.AVOD_DP_E_error_ok]: 'OK',
}
